import { useEffect, useRef } from "react"
import { useRouter } from "next/router"
import { useGrowthBook } from "@growthbook/growthbook-react"

export default function GrowthBookPageViewTracker() {
    const router = useRouter()
    const gb = useGrowthBook()
    const lastTracked = useRef(null)

    useEffect(() => {
        if (!gb) return

        const trackPageView = url => {
            // Strip query string for dedup comparison (optional)
            const path = url.split("?")[0]
            if (lastTracked.current === path) return
            lastTracked.current = path

            gb.logEvent("Page View", {
                path: url,
                url: window.location.href,
            })
        }

        // Initial page load
        trackPageView(router.asPath)

        // Subsequent navigations
        router.events.on("routeChangeComplete", trackPageView)

        return () => {
            router.events.off("routeChangeComplete", trackPageView)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [gb]) // <-- only re-run if gb instance changes, NOT on every route

    return null
}
